<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
        ></dx-grid>

        <v-dialog persistent v-model="votingDialog" max-width="1000">
            <voting-master-list-person
                :person="presonInfo"
                :reload="reload"
                :close="closeVotingDialog"
            ></voting-master-list-person>
        </v-dialog>

        <v-dialog v-model="vhDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="pl-0 pt-0 headline mb-2"
                    >Update VH Status</v-card-title
                >
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">Account ID:</div>
                    <div>{{ clickedRow.familyID }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">Student ID:</div>
                    <div>{{ clickedRow.studentID }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">Student Name:</div>
                    <div>
                        {{ clickedRow.hebName + " " + clickedRow.lastNameH }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">Father:</div>
                    <div>
                        {{ clickedRow.father }}
                    </div>
                </v-layout>

                <div class="font-weight-medium mr-2">VM Status:</div>
                <div class="mb-2">
                    {{ clickedRow.familyVMStatus }}
                </div>

                <v-select
                    v-if="isAllowedUpdating()"
                    v-model="clickedRow.vhStatus"
                    label="Student VH Status"
                    class="mb-2"
                    :items="vhStatuses.map((s) => s.value)"
                    clearable
                ></v-select>

                <v-textarea
                    v-if="isAllowedUpdating()"
                    v-model="clickedRow.vhNote"
                    label="VH Note"
                    rows="2"
                    class="mb-2"
                ></v-textarea>

                <!-- <v-select
                    v-if="isAllowedUpdating()"
                    v-model="clickedRow.familyVHstatus"
                    label="Family VH Status"
                    class="mb-2"
                    :items="['OK', 'PROBLEM']"
                    clearable
                ></v-select> -->

                <!-- <v-select
                    v-model="clickedRow.familyVMStatus"
                    label="VM Status"
                    class="mb-2"
                    :items="['OK', 'PROBLEM']"
                    clearable
                ></v-select> -->

                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="vhDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        v-if="isAllowedUpdating()"
                        color="success"
                        :loading="processing"
                        @click="save"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card></v-dialog
        >

        <v-dialog persistent v-model="assignAppointmentDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-2">{{
                    clickedRow.appointmentDate
                        ? "Unassign Appointment"
                        : "Assign Appointment"
                }}</v-card-title>
                <div class="pb-3">
                    {{ clickedRow.hebName + " " + clickedRow.lastNameH }}
                </div>

                <div v-if="!clickedRow.appointmentDate">
                    <v-date-picker
                        style="border: 2px solid #4caf50; border-radius: unset;"
                        v-model="selectedAppointmentDate"
                        class=""
                        width="360"
                        :events="appointmentSlotEvents"
                        @input="appointmentDateSelected"
                    ></v-date-picker>
                    <v-select
                        class="mt-3"
                        v-model="selectedAppointmentTime"
                        label="Time"
                        :items="appointmentTimes"
                    ></v-select>
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="reset()">Cancel</v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        v-if="!clickedRow.appointmentDate"
                        @click="saveAppointment()"
                    >
                        Save
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        v-if="clickedRow.appointmentDate"
                        @click="unassignAppointment()"
                    >
                        Unassign Appointment
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import votingMasterListPerson from "../Votes/VotingMasterListPerson.vue";
import { loadOptions } from "../../utils/smLookup.js";
import { groupBy } from "../../utils/helpers.js";

export default {
    components: {
        votingMasterListPerson,
    },
    data: () => ({
        title: "Applicant Students",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",

        processing: false,
        selected: [],
        clickedRow: {},
        votingDialog: false,
        presonInfo: {},
        vhDialog: false,
        vhStatuses: [],

        date: "",

        assignAppointmentDialog: false,

        appointmentSlots: [],
        appointmentSlotEvents: [],
        appointmentTimes: [],
        selectedAppointmentDate: "",
        selectedAppointmentTime: "",

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "engName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name H",
                field: "lastNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name H",
                field: "hebName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Account ID",
                template: "link-action-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return true;
                },
            },
            {
                field: "father",
                label: "Father",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "personID",
                label: "Ansl ID",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "votingStatus",
                label: "Voting Status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Voucher Status",
                field: "voucherStatus",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Term",
                field: "regID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student VH Status",
                field: "vhStatus",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "VH Note",
                field: "vhNote",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Family VH Status",
                field: "familyVHstatus",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Family VM Status",
                field: "familyVMStatus",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Start Date",
                field: "startDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Appointment Date",
                field: "appointmentDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Appointment Time",
                field: "appointmentTime",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Time Sort",
                field: "timeSort",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Only Applicant Students",
                field: "hasOnlyApplicantStudents",
                format: "",
                type: "boolean",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Immunization",
                field: "imm",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    watch: {},
    async created() {
        this.columns.find((c) => c.field == "votingStatus").linkAction = (
            row,
        ) => {
            this.openVotingDialog(row);
        };

        this.columns.find((c) => c.field == "familyID").linkAction = (
            account,
        ) => {
            this.toAccount(account);
        };

        this.columns.find((c) => c.field == "vhStatus").linkAction = (row) => {
            this.openVhDialog(row);
        };

        this.loadVhStatuses();

        this.loadAppointmentSlots();
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.url = "applicantStudents";
        },
        onRowClicked(row) {
            this.clickedRow = row;

            this.assignAppointmentDialog = true;
        },
        async loadAppointmentSlots() {
            const response = await this.$http.get(
                "api/appointments/loadExistingAppointments?source=NEW CHILD&branch=" +
                    this.userBranch,
            );

            this.appointmentSlots = response
                .filter((a) => !a.studentID)
                .map((appointment) => {
                    appointment.date = moment(appointment.date).format(
                        "YYYY-MM-DD",
                    );

                    appointment.title =
                        appointment.time +
                        (appointment.studentID
                            ? " - " +
                              appointment.hebName +
                              " " +
                              appointment.lastNameH
                            : "");

                    return appointment;
                });
            console.log(this.appointmentSlots);
            this.appointmentSlotEvents = Object.keys(
                groupBy(this.appointmentSlots, "date"),
            ).map((key) => {
                const date = new Date(key);
                return date.toISOString().substr(0, 10);
            });
        },
        toAccount(row) {
            this.$router.push({
                name: "Account View",
                params: {
                    id: row.familyID,
                },
                query: {
                    limitView: true,
                },
            });
        },
        async loadVhStatuses() {
            this.vhStatuses = await loadOptions("VH Student Status");
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        openVhDialog(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            this.vhDialog = true;
        },
        onTermSelected(value) {
            this.regID = value;

            let url =
                "allStudents?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");

            this.url = url += "&grade=&section=&regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        async openVotingDialog(row) {
            if (row.personID == "No Ansl ID") {
                // return this.$notify({
                //     group: "notification",
                //     text: "No Ansl ID",
                //     type: "warning",
                // });

                this.presonInfo = {
                    firstEnglish: row.fatherEng,
                    lastEnglish: "",
                    titleHebrew: "",
                    suffixHebrew: "",
                    firstHebrew: row.father,
                    lastHebrew: "",
                    address1: row.address1,
                    city: "",
                    state: "",
                    zip: "",
                    father: "",
                    fatherInLaw: "",
                    parentId: row.familyID,
                };

                this.votingDialog = true;

                return;
            }

            this.presonInfo = await this.$http.get(
                "api/applicantStudents/getPersonByID?personID=" + row.personID,
            );

            this.votingDialog = true;
        },
        closeVotingDialog() {
            this.votingDialog = false;
        },
        reload() {
            this.$refs.grid.reloadGrid();
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        isAllowedUpdating() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("VH Status") || this.isAdmin();
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        async save() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/applicantStudents/save",
                    this.clickedRow,
                );

                this.vhDialog = false;
                this.processing = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        appointmentDateSelected(date) {
            this.appointmentTimes = this.appointmentSlots
                .filter((a) => a.date == date)
                .map((a) => a.time);
        },
        async saveAppointment() {
            if (!this.selectedAppointmentDate) {
                return this.$notify({
                    text: "No Date Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.selectedAppointmentTime) {
                return this.$notify({
                    text: "No Time Selected",
                    group: "notification",
                    type: "error",
                });
            }

            const slot = this.appointmentSlots.find(
                (a) =>
                    a.date == this.selectedAppointmentDate &&
                    a.time == this.selectedAppointmentTime,
            );

            if (!slot) return;

            try {
                this.processing = true;

                const appointment = JSON.parse(JSON.stringify(slot));

                appointment.studentID = this.clickedRow.studentID;
                appointment.familyID = this.clickedRow.familyID;
                appointment.source = "NEW CHILD";

                await this.$http.post("api/appointments/save", appointment);

                this.$refs.grid.reloadGrid();

                this.processing = false;

                this.reset();
            } catch (e) {
                this.processing = false;
            }
        },
        async unassignAppointment() {
            try {
                this.processing = true;

                const slot = await this.$http.get(
                    "api/appointments/getByID?id=" +
                        this.clickedRow.appointmentID,
                );

                if (!slot) {
                    this.processing = false;

                    return;
                }
                const appointment = JSON.parse(JSON.stringify(slot));

                appointment.studentID = null;
                appointment.familyID = null;
                appointment.source = "NEW CHILD";

                await this.$http.post("api/appointments/save", appointment);

                this.$refs.grid.reloadGrid();

                this.processing = false;

                this.reset();
            } catch (e) {
                this.processing = false;
            }
        },
        reset() {
            this.assignAppointmentDialog = false;

            this.appointmentSlots = [];
            this.appointmentSlotEvents = [];
            this.appointmentTimes = [];
            this.selectedAppointmentDate = "";
            this.selectedAppointmentTime = "";

            this.loadAppointmentSlots();
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
